import httpClient from '@/apis/base/httpclient';
import BaseAPI from '@/apis/base/baseApi';
import webSocket from '@/sockets/socket';

class RequestAPI extends BaseAPI {
  constructor() {
    super();
  }

  apiName = 'Business';
  controllerName = 'Requests';

  //Đường dẫn api
  getRequestByFilter = 'list-request';
  rejectRequests = 'reject';

  //danh sách request
  listLicense = 'list-license';

  listRequestApprove = 'list-request-approve';
  createdRequest = 'employee-created';

  // Parent-Child Request endpoints
  multiBranchRequest = 'multi-branch';
  parentRequestDetail = 'parent';

  /**
   * Lấy danh sách request có filter
   */
  async getListRequest(model, loading = true) {
    let request = {
      url: [this.getAPIUrl(), this.getRequestByFilter].join('/'),
      data: model,
    };
    var res = httpClient.postAsync(request, loading);
    return res;
  }

  /**
   * Lấy danh sách request có filter
   */
  async getListRequestNeedApprove(model, loading = true) {
    let request = {
      url: [this.getAPIUrl(), this.listRequestApprove].join('/'),
      data: model,
    };
    var res = httpClient.postAsync(request, loading);
    return res;
  }

  /**
   * Approve & Reject request
   */
  async rejectRequest(model) {
    let request = {
      url: [this.getAPIUrl(), this.rejectRequests].join('/'),
      data: model,
    };

    var res = httpClient.postAsync(request);

    return res;
  }

  async getEmployeeCreatedRequest() {
    let request = {
      url: [this.getAPIUrl(), this.createdRequest].join('/'),
    };

    var res = httpClient.getAsync(request);

    return res;
  }

  /**
   * Tạo multi-branch request cho nhiều chi nhánh
   * Created by: hbviet
   * Created date: 14/07/2025
   */
  async createMultiBranchRequest(payload, loading = true) {
    let request = {
      url: [this.getAPIUrl(), this.multiBranchRequest].join('/'),
      data: payload,
    };

    var res = httpClient.postAsync(request, loading);
    return res;
  }

  /**
   * Lấy chi tiết parent request với children
   * Created by: hbviet
   * Created date: 14/07/2025
   */
  async getParentRequestDetail(parentId, loading = true) {
    let request = {
      url: [this.getAPIUrl(), this.parentRequestDetail, parentId].join('/'),
    };

    var res = httpClient.getAsync(request, loading);
    return res;
  }

  /**
   * Lấy danh sách children của parent request
   * Created by: hbviet
   * Created date: 14/07/2025
   */
  async getRequestChildren(parentId, loading = true) {
    let request = {
      url: [this.getAPIUrl(), this.parentRequestDetail, parentId, 'children'].join('/'),
    };

    var res = httpClient.getAsync(request, loading);
    return res;
  }

  /**
   * Update parent status sau khi child status thay đổi
   * Created by: hbviet
   * Created date: 14/07/2025
   */
  async updateParentStatus(parentId, loading = true) {
    let request = {
      url: [this.getAPIUrl(), this.parentRequestDetail, parentId, 'status'].join('/'),
    };

    var res = httpClient.putAsync(request, loading);
    return res;
  }

  /**
   * Approve multiple requests (parent and children)
   * Created by: hbviet
   * Created date: 15/01/2025
   */
  async approveMultipleRequests(parameters, loading = true) {
    let request = {
      url: [this.getAPIUrl(), 'approve-multi'].join('/'),
      data: parameters,
    };

    var res = httpClient.postAsync(request, loading);
    return res;
  }

  /**
   * Reject multiple requests (parent and children)
   * Created by: hbviet
   * Created date: 15/01/2025
   */
  async rejectMultipleRequests(parameters, loading = true) {
    let request = {
      url: [this.getAPIUrl(), 'reject-multi'].join('/'),
      data: parameters,
    };

    var res = httpClient.postAsync(request, loading);
    return res;
  }

  /**
   * Description: Lấy thông tin company cho form LicenseInfo
   * Created by: hbviet
   * Created date: 21/01/2025
   */
  async getCompanyInfo(companyCode, loading = true) {
    let request = {
      url: [this.getAPIUrl(), 'company-info', companyCode].join('/'),
    };

    var res = httpClient.getAsync(request, loading);
    return res;
  }

  async getLicenseSuman(applicationUrl, loading = true) {
    const request = {
      url: [this.getAPIUrl(), `license-suman?applicationUrl=${applicationUrl}`].join('/'),
    };
    return httpClient.getAsync(request, loading);
  }

  async getLicenseSumanByCompanyCodes(companyCodes, loading = true) {
    const request = {
      url: [this.getAPIUrl(), `license-suman-batch?companyCodes=${encodeURIComponent(companyCodes.join(','))}`].join('/'),
    };
    return httpClient.getAsync(request, loading);
  }

  /**
   * Danh sách mã hàng hóa CRM theo national (crm_product_code_map) — option combobox Mã hàng hóa
   * khối CRM Order Information. BE trả nguyên rows (kèm tier/us_group/transaction_type);
   * FE tự chọn mã mặc định theo ngữ cảnh request (commons/crmProductCode.js).
   * BUG-009: usGroup (LUQRA/MAC) filter theo đối tác — null/empty thì bỏ filter.
   */
  async getCrmProductCodes(national, usGroup = null, loading = false) {
    const params = { national };
    if (usGroup) params.us_group = usGroup;
    const request = {
      url: [this.getAPIUrl(), 'crm-product-codes'].join('/'),
      params,
    };
    return httpClient.getAsync(request, loading);
  }

  /**
   * Tìm kiếm đơn hàng cha bên CRM (BUG-005) — nguồn remote-search cho combobox "Đơn hàng cha"
   * khối CRM Order Information. BE proxy CRM POST /saleorder/ParentList, FE không gọi thẳng CRM.
   */
  async searchCrmParentSaleOrder(keyword, pageSize = 10, pageIndex = 1, loading = false) {
    const request = {
      url: [this.getAPIUrl(), 'crm-parent-sale-order'].join('/'),
      params: { keyword, pageSize, pageIndex },
    };
    return httpClient.getAsync(request, loading);
  }

  async resendCrm(requestId, loading = true) {
    const request = {
      url: [this.getAPIUrl(), requestId, 'resend-crm'].join('/'),
    };
    return httpClient.postAsync(request, loading);
  }

  async resendIms(requestId, loading = true) {
    const request = {
      url: [this.getAPIUrl(), requestId, 'resend-ims'].join('/'),
    };
    return httpClient.postAsync(request, loading);
  }

  async createQuickLoginUrl(company_code, domain) {
    let request = {
      url: [this.getAPIUrl(), 'quick-login-url'].join('/'),
      data: {
        domain,
        company_code,
      },
    };

    var res = httpClient.postAsync(request);

    return res;
  }

  /**
   * Tạo quick login URL và mở trong tab mới (PBI 1254057).
   * BE trả Data = URL string trỏ về trang waiting của V2 (/loyalty/quick-login#grant=...).
   */
  async navigateQuickLogin(company_code, domain) {
    const newTab = window.open('', '_blank');

    try {
      const resp = await this.createQuickLoginUrl(company_code, domain);
      const url = resp?.Data;
      if (url && newTab) {
        newTab.location.href = url;
      } else {
        newTab?.close();
      }
      return url;
    } catch (error) {
      newTab?.close();
      throw error;
    }
  }
}

export default new RequestAPI();
